// extracted by mini-css-extract-plugin
export default {"zoomControls":"laa-z","zoomControlButton":"maa-z","zoomBanner":"naa-z","bannerButton":"oaa-z","imageButton":"paa-z","zoom":"qaa-z","zoomContent":"raa-z"};